<template>
  <div class="users-permissions-form">

    <el-row :gutter="20">
      <el-col :span="8">
        <el-form-item
          label="Distribuidor"
          prop="dealerId"
        >
          <el-select
            v-model="model.dealerId"
            filterable
            @change="searchBranchesByDealer"
          >
            <el-option
              v-for="dealer in dealers"
              :key="dealer.id"
              :value="dealer.id"
              :label="dealer.name"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label="Sucursal"
          prop="branchId"
        >
          <el-select
            v-model="selectedBranches"
            multiple
            filterable
            :disabled="!model.dealerId"
            :loading="branches === null"
          >
            <el-option
              v-for="branch in branches"
              :key="branch.id"
              :value="branch.id"
              :label="branch.municipality + ', ' + branch.state"
            >
              {{ branch.municipality }}, {{ branch.state }}
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label="Divisiones"
        >
          <el-select
            multiple
            v-model="selectedDivisions"
            placeholder="Seleccione las divisiones"
          >
            <el-option
              v-for="division in divisions"
              :key="division.name"
              :value="division.name"
              :label="division.name"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-button
          @click="addPermissions"
        >
          Agregar Regla
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import http from '@/services/http.service'

/**
   * 'UsersPermissionsForm' Component
   * @version 1.0.0
   * @author Fernando Torres
   * @copyright Marciano Studio S.C., 2018
   */
export default {
  name: 'UsersPermissionsForm',
  inject: ['dealers', 'divisions'],
  data () {
    return {
      arrChecked: [],
      tempArr: [],
      findVal: '',
      value: [],
      model: [],
      branches: [],
      selectedBranches: [],
      selectedDivisions: [],
      permissions: [],
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'leaf'
      }
    }
  },
  methods: {
    addPermissions () {
      for (let branchId of this.selectedBranches) {
        for (let division of this.selectedDivisions) {
          this.permissions.push({
            dealerId: this.model.dealerId,
            dealer: this.dealers.find(x => x.id === this.model.dealerId),
            branchId: branchId,
            branch: this.branches.find(x => x.id === branchId),
            division: division
          })
        }
      }
      this.model.dealerId = null
      this.selectedBranches = []
      this.branches = null
      this.selectedDivisions = []
      this.$emit('input', this.permissions)
    },
    searchBranchesByDealer () {
      this.model.branchId = null
      this.branches = null
      this.selectedBranches = []
      http.get('branches', {params: {'filters[where][dealerId][eq]': this.model.dealerId, limit: 1000}})
        .then(response => {
          this.branches = response.data.items
        })
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
  .users-permissions-form {

  }

  .ms-grid {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/modules/users/users-permissions-form.vue